import { mapState, mapActions, mapGetters, mapMutations } from 'vuex'
import { apiGetCalculation, apiPostCalculation } from '@/services/API/gag'
import maInputCheckbox from '@/components/input/modules/checkbox'
import maInputSelect from '@/components/input/modules/select'
import maInputText from '@/components/input/modules/text'
import maTabSelector from '@/components/tabSelector'
import maMixClickableCell from '../mixClickableCell'
import maToggleButton from '@/components/input/modules/toggleButton'
import maEventBus from '@/components/eventbus'
import maModal from '@/components/modal'
import maRange from '@/components/range'
import maLoader from '@/components/loader'
import {
  WARRANTY_MODULE_NAME,
  WARRANTY_DELETE_DAMAGE,
  WARRANTY_GET_REPORT,
  WARRANTY_UPDATE_REPAIR_TYPE,
  WARRANTY_PATCH_REPAIR_TYPE,
  WARRANTY_UPDATE_DAMAGE_REPARATION_TYPE
} from '@/store/types'
import {
  PHOTOS_OPTIONS,
  ENSEMBLE_IMAGE,
  PRES_IMAGE,
  MIX_KEY,
  REGULAR_KEY
} from '@/constants'

export default {
  name: 'damageSummary',

  data: function() {
    return {
      selectedRepairType: null,
      totals: {
        gag: 0,
        materials: 0,
        estimated_time: 0,
        authorized_network_repair: 0,
        authorized_network_repair_without_taxes: 0,
        artessian_repair: 0,
        artessian_repair_without_taxes: 0,
        immediate: 0,
        difference: 0,
        max_valorization_alarm: 0
      },
      gag: {
        csp_salary: null,
        age: null,
        client_vip: false
      },
      range: {
        max_price: 0,
        min_price: 0,
        recommended_price_hour: 0,
        standard_price: 0
      },
      price: null,
      cspSalaryOptions: [],
      damagePhotos: {},
      ctx: null,
      canvas: null,
      scale: 0,
      scaleStep: 0.15,
      minScale: 0,
      maxScale: 2,
      gagKey: 'GAG',
      networkRepairKey: 'REN',
      artessianRepairKey: 'ASP',
      isMixAvailable: false,
      mixCompensationButtonOptions: [
        { key: REGULAR_KEY, literal: 'Regular' },
        { key: MIX_KEY, literal: 'Mix Compensacion' }
      ],
      totalAmount: 0,
      globalTotalAmount: 0,
      isLoaderActive: false,
      gagInput: false,
      renInput: false,
      aspInput: false
    }
  },

  components: {
    maModal,
    maRange,
    maInputSelect,
    maInputText,
    maInputCheckbox,
    maTabSelector,
    maMixClickableCell,
    maToggleButton,
    maLoader
  },

  computed: {
    ...mapState(WARRANTY_MODULE_NAME, {
      stateWarrantySinisterId: 'sinisterId',
      stateWarrantyZipCode: 'zipCode',
      stateWarrantyReport: 'report',
      stateWarrantyRepairType: 'repairType'
    }),
    ...mapGetters(WARRANTY_MODULE_NAME, {
      getWarrantySinisterDamagesCount: 'sinisterDamagesCount'
    }),

    warrantiesList: function() {
      return this.stateWarrantyReport && this.stateWarrantyReport.warranties
    },
    reduxList: function() {
      return this.stateWarrantyReport && this.stateWarrantyReport.redux
    },

    global_totals: function() {
      return this.stateWarrantyReport && this.stateWarrantyReport.global_totals
    },

    damageTypeData: function() {
      return (
        this.stateWarrantyReport && this.stateWarrantyReport.sinister.rep_type
      )
    },
    disableCalcButton: function() {
      if (!this.gag.csp_salary) return true
      if (!this.gag.age) return true

      return false
    },
    totalPropertiesByRepType() {
      return [
        {
          repType: this.gagKey,
          container: 'gag',
          value: 'gag_cost'
        },
        {
          repType: this.networkRepairKey,
          container: 'authorized_network_repair',
          value: 'new_value_with_taxes'
        },
        {
          repType: this.artessianRepairKey,
          container: 'artessian_repair',
          value: 'new_value_with_taxes'
        }
      ]
    }
  },
  methods: {
    ...mapActions(WARRANTY_MODULE_NAME, {
      actWarrantyDeleteDamage: WARRANTY_DELETE_DAMAGE,
      actWarrantyGetReport: WARRANTY_GET_REPORT,
      actWarrantyPatchRepairType: WARRANTY_PATCH_REPAIR_TYPE,
      actWarrantyUpdateDamageRepType: WARRANTY_UPDATE_DAMAGE_REPARATION_TYPE
    }),
    ...mapMutations(WARRANTY_MODULE_NAME, {
      mutWarrantyUpdateRepairType: WARRANTY_UPDATE_REPAIR_TYPE
    }),

    handleChangeRepairType(repairType, analysisView) {
      let payload = {
        rep_type: repairType,
        analysis_view: analysisView
      }

      this.actWarrantyPatchRepairType(payload)
      this.mutWarrantyUpdateRepairType(payload.rep_type)

      this.selectedRepairType = this.stateWarrantyRepairType
    },

    showManpower: function() {
      const that = this
      apiGetCalculation(
        this.stateWarrantySinisterId,
        this.gag.csp_salary,
        this.gag.age,
        this.gag.client_vip
      )
        .then(data => {
          that.range.max_price = data.max_price
          that.range.min_price = data.min_price
          that.range.standard_price = data.standard_price
          that.price = that.price || data.standard_price
          debugger
          this.$refs.manpowerModal.$data.showModal = true
        })
        .catch(() => {
          that.throwNotification(
            that.$i18n.t('error.notifications.0.title'),
            that.$i18n.t('error.notifications.0.text'),
            'KO'
          )
        })
    },

    preparePhotosModal(damage) {
      let damagePhotos = {
        damageName: damage.damage,
        activeTab: null,
        activePhotoIndex: 0,
        tabs: [],
        get showTabSelector() {
          return this.tabs.length > 1
        },
        get activePhotoUrl() {
          if (!this.activeTab || !this[this.activeTab] || !this[this.activeTab].length) {
            return null
          }
          const activePhoto = this[this.activeTab][this.activePhotoIndex]
          return activePhoto ? activePhoto.imageURL : null
        }
      }
      
      let tabs = []
      
      const presImages = damage.images.filter(image => image.imageType === PRES_IMAGE)
      if (presImages.length > 0) {
        tabs.push(PHOTOS_OPTIONS[1])
        damagePhotos[PRES_IMAGE] = presImages
        damagePhotos.activeTab = PRES_IMAGE
      }
      
      const ensembleImages = damage.images.filter(image => image.imageType === ENSEMBLE_IMAGE)
      if (ensembleImages.length > 0) {
        tabs.push(PHOTOS_OPTIONS[0])
        damagePhotos[ENSEMBLE_IMAGE] = ensembleImages
        if (!damagePhotos.activeTab) {
          damagePhotos.activeTab = ENSEMBLE_IMAGE
        }
      }
      
      if (!damagePhotos.activeTab && damage.images.length > 0) {
        const fallbackKey = 'allImages'
        damagePhotos[fallbackKey] = damage.images.filter(image => image != null);
        damagePhotos.activeTab = fallbackKey
        tabs.push({ key: fallbackKey, literal: 'All' })
      }
      
      damagePhotos.tabs = tabs

      if (damagePhotos.activeTab) {
        this.handlePhotosModal(damagePhotos)
        this.disablePhotoIcon()
      }
    },

    handlePhotosModal(damagePhotos) {
      this.damagePhotos = damagePhotos
      this.$refs.photosModal.$data.showModal = true
      this.handleLoadPhoto()
      window.addEventListener('resize', this.handleLoadPhoto)
    },

    handleLoadPhoto() {
      const img = this.damagePhotos.activePhotoUrl

      if (!img) {
        return
      }

      this.scale = 1
      this.minScale = 1
      setTimeout(() => {
        this.canvas = this.$refs.canvas
        this.ctx = this.canvas.getContext('2d')

        this.target = new Image()
        this.target.src = img

        this.target.onload = () => {
          this.renderImage(this.target)
        }
        
        this.target.onerror = () => {}
      }, 100)
    },

    renderImage(target) {
      // Fit image to rendered (visible) container width.
      this.canvas.width = target.width
      this.canvas.style.width = '100%'
      this.canvas.height =
        (target.height * this.canvas.width) / this.target.width

      // Draw image.
      this.ctx.drawImage(
        this.target,
        0,
        0,
        this.canvas.width,
        this.canvas.height
      )
    },

    handleZoomIn() {
      if (this.scale >= this.maxScale) {
        this.scale = this.maxScale
      } else {
        this.scale += this.scaleStep
      }

      this.handleZoomImage()
    },

    handleZoomOut() {
      if (this.scale <= this.minScale) {
        this.canvas.style.width = '100%'
      } else {
        this.scale -= this.scaleStep
        this.handleZoomImage()
      }
    },

    handleZoomImage() {
      this.canvas.style.width = `${100 * this.scale}%`
    },

    handleTabClick(value) {
      if (this.damagePhotos.activeTab !== value) {
        this.damagePhotos.activeTab = value
        this.damagePhotos.activePhotoIndex = 0
        this.handleLoadPhoto()
      }
    },

    handleThumbnailClick(index) {
      this.damagePhotos.activePhotoIndex = index
      this.handleLoadPhoto()
    },

    calcWarrantiesTotals: function() {
      if (!this.isMixAvailable) {
        const totals = this.stateWarrantyReport.global_totals

        this.totals.gag = totals.gag
        this.totals.materials = totals.materials
        this.totals.estimated_time = totals.estimated_time
        this.totals.authorized_network_repair = totals.authorized_network_repair
        this.totals.authorized_network_repair_without_taxes =
          totals.authorized_network_repair_without_taxes
        this.totals.artessian_repair = totals.artessian_repair
        this.totals.artessian_repair_without_taxes =
          totals.artessian_repair_without_taxes
        this.totals.immediate = totals.immediate
        this.totals.difference = totals.difference
        this.totals.max_valorization_alarm = totals.max_valorization_alarm
      } else {
        // Set all totals values to 0
        Object.keys(this.totals).forEach(key => {
          this.totals[key] = 0
        })

        Object.keys(this.stateWarrantyReport.redux).map(key => {
          let pieceTotals = this.stateWarrantyReport.redux[key]
          let totals

          pieceTotals.map(piece => {
            totals = piece.professions[0].totals
          })

          this.totals.gag += totals.total_gag_cost_mix
          this.totals.materials += totals.total_material_cost_mix
          this.totals.estimated_time += totals.manpower_hours_mix
          this.totals.authorized_network_repair +=
            totals.authorized_network_repair_mix
          this.totals.authorized_network_repair_without_taxes +=
            totals.authorized_network_repair_without_taxes_mix
          this.totals.artessian_repair += totals.artessian_repair_mix
          this.totals.artessian_repair_without_taxes +=
            totals.artessian_repair_without_taxes_mix
          this.totals.immediate += totals.immediate
          this.totals.difference += totals.difference
          // this.totals.max_valorization_alarm (backend ?)
        })

        this.totalAmount =
          this.totals.gag +
          this.totals.authorized_network_repair +
          this.totals.artessian_repair
      }

      if (this.global_totals) {
        this.globalTotalAmount =
          this.global_totals.gag_mix +
          this.global_totals.authorized_network_repair_mix +
          this.global_totals.artessian_repair_mix
      }

      this.isLoaderActive = false
    },

    handleManpowerChange: function(event) {
      this.gag[event.inputId] = event.inputVal
    },

    handleSetPriceButtonClick: function() {
      const that = this
      apiPostCalculation(this.stateWarrantySinisterId, this.price)
        .then(() => {
          this.actWarrantyGetReport().then(() => {
            this.throwNotification(
              this.$t('notifications.moCalculation.title'),
              this.$t('notifications.moCalculation.body'),
              'OK'
            )
          })
        })
        .catch(() => {
          this.throwNotification(
            this.$t('notifications.error.title'),
            this.$t('notifications.error.body'),
            'KO'
          )
        })
        .finally(() => {
          that.$refs.manpowerModal.showModal = false
        })
    },

    handleRemoveDamage: function(damageId) {
      const that = this
      this.actWarrantyDeleteDamage(damageId)
        .then(() => {
          maEventBus.$emit('damage:remove', damageId)
          that.throwNotification(
            that.$i18n.t('notifications.deleteDamage.title'),
            this.$t('notifications.deleteDamage.body'),
            'OK'
          )

          if (that.getWarrantySinisterDamagesCount <= 1) {
            maEventBus.$emit('summary:collapse')
          }

          if (this.FNOLFlow.isExecuting) {
            window.parent.postMessage({ updated: 'damage' }, '*')
          }
        })
        .catch(() => {
          this.throwNotification(
            this.$t('notifications.error.title'),
            this.$t('notifications.error.body'),
            'KO'
          )
        })
    },

    getCostBackgroundColor: function(cost) {
      return cost < this.totals.max_valorization_alarm ||
        this.totals.max_valorization_alarm === 0
        ? 'bg-green'
        : 'bg-red'
    },

    isRepairTypeChecked(repairType) {
      if (this.selectedRepairType) {
        return this.selectedRepairType.rep_type === repairType
          ? 'checked'
          : null
      }
    },

    getDamagesList: function(damageGroup) {
      return damageGroup && damageGroup.damages
    },

    listCounterWidthSet() {
      const separation = 8

      let greAGreWidth = document.querySelector('#greAGreColumn').offsetWidth
      let greAGreTotal = document.querySelector('#greAGreTotal')
      greAGreTotal.style.width = `${greAGreWidth - separation}px`

      let reparationNetWorkWidth = document.querySelector(
        '#reparationNetworkColumn'
      ).offsetWidth
      let reparationNetworkTotal = document.querySelector(
        '#reparationNetworkTotal'
      )
      reparationNetworkTotal.style.width = `${reparationNetWorkWidth -
        2 * separation}px`

      let reparationExceptWidth = document.querySelector(
        '#reparationExceptColumn'
      ).offsetWidth
      let removeColumnWidth = document.querySelector('#removeDamageColumn')
        .offsetWidth
      let reparationExceptTotal = document.querySelector(
        '#reparationExceptTotal'
      )
      reparationExceptTotal.style.width = `${reparationExceptWidth +
        removeColumnWidth -
        separation}px`
    },

    updateCheckedOption() {
      this.selectedRepairType = this.stateWarrantyRepairType
        ? this.stateWarrantyRepairType
        : this.damageTypeData
      let optionChecked = document.querySelector(`#${this.selectedRepairType}`)
      optionChecked.setAttribute('checked', '')
    },

    getDamageDescription(damage) {
      const age = damage.damage.age
      const obsolescence = damage.damage.obsolescence
      const quantity = damage.damage.quantite
      const newValue = damage.authorized_network_repair.new_value_with_taxes
      const productData = damage.damage.original_product

      const descriptionItems = []

      if (productData) {
        const productDetails = `${productData.brand} ${productData.model}`
        descriptionItems.push(productDetails)
      }
      descriptionItems.push(damage.damage.description)

      if (quantity > 0) {
        descriptionItems.push(`${(newValue / quantity).toFixed(2)}€`)
      }
      if (age > 0) {
        descriptionItems.push(age.toString())
      }
      if (obsolescence) {
        descriptionItems.push(obsolescence)
      }
      if (quantity > 0) {
        descriptionItems.push(
          `${quantity} ${this.$t(
            'warrantySticky.damageSummary.description.quantity'
          )}`
        )
      }

      return descriptionItems.join(', ')
    },

    handleOnSelectTotal(data) {
      // Frontend Workaround (for selecting one cell per row)
      this.isLoaderActive = true
      this.actWarrantyUpdateDamageRepType(data).catch(e => console.error(e))
    },

    async handleMixButton(option) {
      this.isMixAvailable = option === MIX_KEY
      this.isLoaderActive = true
      this.handleChangeRepairType(
        this.isMixAvailable ? 'MIX' : this.stateWarrantyRepairType,
        this.isMixAvailable ? 'MIX' : 'REGULAR'
      )
      await this.actWarrantyGetReport()
      this.isLoaderActive = false
    }
  },

  watch: {
    stateWarrantyReport: function() {
      this.calcWarrantiesTotals()
    }
  },

  created() {
    this.isLoaderActive = true
    this.gagInput = true
    window.addEventListener('resize', this.listCounterWidthSet)
    this.listCounterWidthSet()
  },

  updated() {
    if (this.selectedRepairType === 'GAG') {
      this.gagInput = true
      this.aspInput = false
      this.renInput = false
    } else if (this.selectedRepairType === 'ASP') {
      this.aspInput = true
      this.renInput = false
      this.gagInput = false
    } else if (this.selectedRepairType === 'REN') {
      this.renInput = true
      this.gagInput = false
      this.aspInput = false
    }
    this.listCounterWidthSet()
    this.updateCheckedOption()
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.listCounterWidthSet)
    window.removeEventListener('resize', this.handleLoadPhoto)
  }
}
